import DrawerResizerController from '@app/application/behaviors/drawers/drawer-resizer-controller'
import { leftDrawerLayout } from '@app/application/behaviors/drawers/left-drawer-layout'

// Drag-to-resize handle on the right edge of the new layout's left drawer.
export default class extends DrawerResizerController {
  protected readonly layout = leftDrawerLayout
  protected readonly resizingClass = 'left-drawer-resizing'
  protected readonly widenKey = 'ArrowRight'
}
